/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CountBubble from 'DesignSystem/CountBubble/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/Tasks/PendingCounter/Content/Content"
  
}) {
let constantData = ' '
let dtColorsRed700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700'
        })
  return (<React.Fragment
>
<CountBubble
  viewPath={`${viewPath}/CountBubble`}
 position="absolute"
 top={2}
 right={2}
 backgroundColor={dtColorsRed700}
 size="small"
 paddingLeft={0}
 data="' '"
 text={constantData}
/>
{children}
</React.Fragment>)
}